const CmsPrescriptionEntryKeys = [
    'existing-customer',
    'email',
    'file-upload',
    'form-upload',
    'form-entry',
    'book-appointment', 
];

export { CmsPrescriptionEntryKeys };
//# sourceMappingURL=cms.js.map
